import {useEffect, useState} from 'react';
import {useHttpClient} from '../security/hooks/axiosProvider';
import {SubActivity} from "../pages/accueil/model/types";

export const useSubActivity = () => {
    const [subActivities, setSubActivities] = useState<Array<SubActivity>>([]);
    const httpClient = useHttpClient();

    useEffect(() => {
        const fetchSubActivities = async () => {
            try {
                const response = await httpClient.current?.get('/api/subactivity/all');
                setSubActivities(response.data);
            } catch (error) {
                console.log('Error fetching sub activities:', error);
            }
        };

        fetchSubActivities();
    }, [httpClient]);

    return {subActivities};
};
